@if (toast) {
    <ngb-toast [autohide]="autohide" [class]="className" (hidden)="onHidden()">
        <div class="d-flex align-items-center">
            @if (toast.routerLink) {
                <a [routerLink]="toast.routerLink">{{ toast.message }}</a>
            } @else {
                <div>{{ toast.message }}</div>
            }
            <wdx-icon
                class="ms-auto"
                [fixedWidth]="true"
                [icon]="icon"
                size="lg"
            ></wdx-icon></div
    ></ngb-toast>
}
